import { render } from "./Group.vue?vue&type=template&id=2f22df87&scoped=true&ts=true"
import script from "./Group.vue?vue&type=script&lang=ts"
export * from "./Group.vue?vue&type=script&lang=ts"

import "./Group.vue?vue&type=style&index=0&id=2f22df87&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f22df87"]])

export default __exports__